import React, { useState } from "react";
import { Story } from "../../../types";
import StoryView from "./story-view";
import Leaderboard from "./leaderboard";
import { useAppSelector } from "../../../redux/store";
import { selectIsSolo } from "../../../redux/selectors";
import SoloLeaderboard from "./solo-leaderboard";
import Page from "../../common/page/page";
import { useTranslation } from "react-i18next";

type ResultsProps = {
  onGameStats: () => void;
};

export function storyToText(story: Story) {
  let text = "";

  if (story) {
    text += `TITLE: ${story.meta.title}\n`;
    text += `FEATURING THE CHARACTERS: ${story.characters
      ?.filter((c) => c.selected)
      .map((c) => c.name)
      .join(", ")}\n`;

    if (story.submissions.length > 1) {
      text += `WRITERS: ${story.submissions.map((s) => s.player.name).join(", ")}\n`;
    }

    text += `${story.settings.mature ? "RATED 18+" : "RATED ALL AGES"}\n`;
    text += "--------------------\n";
    text +=
      story.submissions
        .map((s) => (s.meta.censored ? "■TEXT REMOVED■" : s.content))
        .join(`\n${"-".repeat(20)}\n`) + "\n";
    text += "\n";
    text += "Fanfic created with #FranticFanfic.";
  }

  return text;
}

const StoryResults = ({ onGameStats }: ResultsProps) => {
  const gameState = useAppSelector((state) => state.game);
  const playerState = useAppSelector((state) => state.player);
  let isSolo = useAppSelector(selectIsSolo);

  const [listView, setListView] = useState(-1);

  const stories = gameState.game?.stories
    ?.slice()
    .sort((a, b) => b.meta.points - a.meta.points);

  const { t } = useTranslation("game");

  if (listView !== -1 && stories) {
    return (
      <StoryView
        subheaders={[
          t("storyResults.subheaders.saveImg"),
          t("storyResults.subheaders.saveTxt"),
          t("storyResults.subheaders.attach"),
        ]}
        me={playerState.player}
        story={stories[listView]}
        onBack={() => setListView(-1)}
        onShare={() => {}}
      />
    );
  }

  if (isSolo) {
    return <SoloLeaderboard onGameStats={onGameStats} />;
  }

  return (
    <Leaderboard
      onGameStats={onGameStats}
      onStoryClick={(idx) => setListView(idx)}
    />
  );
};

export default StoryResults;
